function pageDirection() {
  var _document;
  const dir = (_document = document) === null || _document === void 0 || (_document = _document.documentElement) === null || _document === void 0 ? void 0 : _document.dir;
  return dir === 'rtl' ? 'rtl' : 'ltr';
}

export { pageDirection as p };
//# sourceMappingURL=pageDirection-BYrhGUoU.js.map
